import { 
  GET_KNOWLEDGE_BASE_REQUEST, 
  GET_KNOWLEDGE_BASE_SUCCESS, 
  GET_KNOWLEDGE_BASE_FAILURE,
  ADD_KNOWLEDGE_BASE_REQUEST,
  ADD_KNOWLEDGE_BASE_SUCCESS,
  ADD_KNOWLEDGE_BASE_FAILURE,
  CREATE_DOCUMENT_REQUEST,
  CREATE_DOCUMENT_SUCCESS,
  CREATE_DOCUMENT_FAILURE,
  DELETE_KNOWLEDGE_BASE_REQUEST,
  DELETE_KNOWLEDGE_BASE_SUCCESS,
  DELETE_KNOWLEDGE_BASE_FAILURE,
  GET_KNOWLEDGE_BASE_BY_ID_REQUEST,
  GET_KNOWLEDGE_BASE_BY_ID_SUCCESS,
  GET_KNOWLEDGE_BASE_BY_ID_FAILURE,
  RESET_SELECTED_KNOWLEDGE_BASE
} from '../actions/knowledgeBaseActions';

const initialState = {
  loading: false,
  error: null,
  knowledgeBases: [],
  lastFetched: null,
  selectedKnowledgeBase: null,
  selectedLoading: false
};

export default function knowledgeBaseReducer(state = initialState, action) {
  switch (action.type) {
    case GET_KNOWLEDGE_BASE_REQUEST:
      return { ...state, loading: true, error: null };
    
    case GET_KNOWLEDGE_BASE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        knowledgeBases: action.payload.data || [],
        lastFetched: new Date().toISOString(),
        error: null 
      };
    
    case GET_KNOWLEDGE_BASE_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.error,
        knowledgeBases: [] 
      };

    case ADD_KNOWLEDGE_BASE_REQUEST:
      return { ...state, loading: true, error: null };
    
    case ADD_KNOWLEDGE_BASE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        knowledgeBases: [...state.knowledgeBases, action.payload.data],
        error: null 
      };
    
    case ADD_KNOWLEDGE_BASE_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };

    case CREATE_DOCUMENT_REQUEST:
      return { ...state, loading: true, error: null };
    
    case CREATE_DOCUMENT_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        knowledgeBases: [...state.knowledgeBases, action.payload.data],
        error: null 
      };
    
    case CREATE_DOCUMENT_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };

    case DELETE_KNOWLEDGE_BASE_REQUEST:
      return { ...state, loading: true, error: null };
    
    case DELETE_KNOWLEDGE_BASE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        knowledgeBases: state.knowledgeBases.filter(item => item._id !== action.payload.id),
        error: null 
      };
    
    case DELETE_KNOWLEDGE_BASE_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };

    case GET_KNOWLEDGE_BASE_BY_ID_REQUEST:
      return { ...state, selectedLoading: true, error: null };
    
    case GET_KNOWLEDGE_BASE_BY_ID_SUCCESS:
      return { 
        ...state, 
        selectedLoading: false, 
        selectedKnowledgeBase: action.payload.data,
        error: null 
      };
    
    case GET_KNOWLEDGE_BASE_BY_ID_FAILURE:
      return { 
        ...state, 
        selectedLoading: false, 
        error: action.error 
      };

    case RESET_SELECTED_KNOWLEDGE_BASE:
      return { 
        ...state, 
        selectedKnowledgeBase: null,
        selectedLoading: false,
        error: null 
      };

    default:
      return state;
  }
}
